<mat-form-field appearance="outline" class="w-100" id="multiple">
  <mat-select [multiple]="true" [required]="required" [disabled]="disabled"
    (openedChange)="openedChange($event)" #multiple [overlapTrigger]="false">
    <mat-select-trigger>
       {{ model && model[0] === 'All' ? 'ALL' : getNames() }}
    </mat-select-trigger>
    <mat-option class="mat-search">
      <ngx-mat-select-search [formControl]="matSelectSearchCtrl" [placeholderLabel]="'Search'"
        [hideClearSearchButton]="false"></ngx-mat-select-search>
    </mat-option>
    <cdk-virtual-scroll-viewport appendOnly itemSize="10" class="example-viewport" style="height: 210px; min-width: 600px;" (scrolledIndexChange)="scrolledIndexChange($event)">
      <mat-option value="All" *ngIf="data.length > 0" #allSelected (click)="optionAllChanges()">All {{selectAll(allSelected)}}</mat-option>
      <mat-option *cdkVirtualFor="let item of filteredData | async" [value]="item" (click)="optionChanges(option)"
        #option>
        {{item.name}}
        {{isSelect(option)}}
      </mat-option>
      <mat-option *ngIf="data.length === 0">No data</mat-option>
    </cdk-virtual-scroll-viewport>
  </mat-select>
</mat-form-field>